import * as React from 'react';
import { observer } from 'mobx-react';

import { MAX_CREATE_BOT_LINK } from 'shared/entities/app';
import { useRootStore } from 'stores/index';
import { useLocal } from 'shared/entities/common/hooks';
import { MAXChannelCreationStore } from 'stores/channelCreationStores';

import FormWithToken from '../FormWithToken';

import MaxInstruction from './MaxInstruction';

const Max: React.FC = () => {
  const rootStore = useRootStore();
  const store = useLocal(() => new MAXChannelCreationStore({ rootStore }));

  return (
    <FormWithToken
      token={store.token}
      url={MAX_CREATE_BOT_LINK}
      creatingBotName="MaxBot"
      placeholder="XXXXXXXXXXXXXXXXX..."
      onCreate={store.create}
      creatingStage={store.creationStage.value}
      disabled={store.isError}
      InstructionSlot={MaxInstruction}
    />
  );
};

export default observer(Max);
